import {useCallback} from "react";

import {invalidateSessionState} from "@/src/modules/auth/lib/invalidate-session-state";

export {invalidateSessionState} from "@/src/modules/auth/lib/invalidate-session-state";

export default function useInvalidateSession() {
  return useCallback(() => invalidateSessionState(), []);
}
